import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import './SingleStopTable.css';

// eslint-disable react/prop-types

export default class SingleStopTable extends Component {
  constructor(props) {
    super(props);
    this.zoneitems = this.zoneitems.bind(this);
    this.getZoneData = this.getZoneData.bind(this);
  }

  zoneitems(data, zone) {
    return Object.keys(data[zone]).reduce(
      (acc, currentValue) => acc + Math.max(1, data[zone][currentValue].length),
      0,
    );
  }

  getZoneData(LAYOUT_loc) {
    const zoneData = {};
    for (var zone in LAYOUT_loc) {
      zoneData[zone] = {};
      zoneData[zone].bays = [];
      zoneData[zone].rowSpan = 0;
    }
    for (zone in LAYOUT_loc) {
      let zoneEmpty = true;
      for (const bay in LAYOUT_loc[zone]) {
        if (LAYOUT_loc[zone][bay].length > 0) {
          zoneEmpty = false;
          const bayData = {};
          bayData[bay] = LAYOUT_loc[zone][bay];
          zoneData[zone].rowSpan += LAYOUT_loc[zone][bay].length;
          zoneData[zone].bays.push(bayData);
        }
      }

      if (zoneEmpty) {
        delete zoneData[zone];
      } else {
        zoneData[zone].bays.sort((a, b) => {
          const bayA = Object.keys(a)[0];
          const bayB = Object.keys(b)[0];
          return bayA.localeCompare(bayB);
        });
      }
    }

    return zoneData;
  }

  render() {
    let LAYOUT_loc = this.props.layout;
    const newItems = Object.keys(this.props.data).filter(
      (x) => this.props.data[x].value > 0,
    );
    const itemLocation = Object.keys(LAYOUT_loc).reduce((accumulator, zone) => {
      accumulator[zone] = {};
      for (const bay in LAYOUT_loc[zone]) {
        accumulator[zone][bay] = LAYOUT_loc[zone][bay].filter((item) =>
          newItems.includes(item),
        );
      }
      return accumulator;
    }, {});
    const allItems = Object.keys(LAYOUT_loc).reduce((accumulator, zone) => {
      return accumulator
        .concat(LAYOUT_loc[zone].A || [])
        .concat(LAYOUT_loc[zone].B || [])
        .concat(LAYOUT_loc[zone].C || []);
    }, []);
    const diff = Object.keys(this.props.data).filter(
      (x) => !allItems.includes(x),
    );

    LAYOUT_loc = JSON.parse(JSON.stringify(itemLocation));
    if (diff.length > 0) {
      LAYOUT_loc.other = { C: diff };
    }

    const zoneData = this.getZoneData(LAYOUT_loc);

    const hasZone4 = zoneData.hasOwnProperty('4');

    const headers = [
      <tr key="header-table">
        <th key="Zone">Zone</th>
        <th key="Bay">Bay</th>
        <th key="Item">Item</th>
        <th key="SkuId">SKU Identifier</th>
        <th key="Need">Need</th>
        {this.props.showToteCounts && <th key="ToteCount">Full Tote Count</th>}
        {this.props.showToteCounts && <th key="PartialCount">Partial Units</th>}
      </tr>,
    ];

    let rows = [];
    if (Object.keys(zoneData).length > 0) {
      rows = Object.keys(zoneData).map((zone) => (
        <tbody className="zoneGroup" key={zone}>
          {zoneData[zone].bays.map((bayData, bayIndex) =>
            Object.keys(bayData).map((bay) =>
              bayData[bay].map((sku, index) => {
                const item = this.props.items.find((it) => it.id === sku);
                const need = this.props.data[sku].value;
                // tote capacity is keyed by packaging type, mirroring the
                // packing slip generation in the backend
                const unitsPerTote =
                  this.props.toteSizes?.[item?.packagingType];
                const hasToteData = unitsPerTote >= 1;
                return (
                  <tr key={sku}>
                    {bayIndex === 0 && index === 0 && (
                      <td
                        className="text-center zoneCell"
                        rowSpan={zoneData[zone].rowSpan}
                      >
                        {zone}
                      </td>
                    )}
                    {index === 0 && (
                      <td
                        className="text-center bayCell"
                        rowSpan={bayData[bay].length}
                      >
                        {bay}
                      </td>
                    )}
                    <td
                      className={
                        this.props.wrapItemNames
                          ? 'nameCell nameCellWrap'
                          : 'nameCell'
                      }
                    >
                      {this.props.useDisplayNames
                        ? item?.prettyName || sku
                        : sku}
                    </td>
                    <td className="skuIdCell">
                      {item?.skuIdentifier || ' - '}
                    </td>
                    <td className="bigger quantityCell">
                      <div>{need}</div>
                      {this.props.data[sku].unitsPerPack > 1 && (
                        <div className="small">
                          (2PK: {need / this.props.data[sku].unitsPerPack})
                        </div>
                      )}
                    </td>
                    {this.props.showToteCounts && (
                      <td className="bigger toteCountCell">
                        {hasToteData ? Math.floor(need / unitsPerTote) : '-'}
                      </td>
                    )}
                    {this.props.showToteCounts && (
                      <td className="bigger partialCountCell">
                        {hasToteData ? need % unitsPerTote : '-'}
                      </td>
                    )}
                  </tr>
                );
              }),
            ),
          )}
        </tbody>
      ));
    } else {
      rows = (
        <tr key="NO-Data">
          <td colSpan={4}>No Data for this date</td>
        </tr>
      );
    }

    return (
      <div
        className={`packingSlip ${
          !hasZone4 && Object.keys(this.props.data).length > 20 ? 'tooBig' : ''
        }`}
        id={this.props.psId}
      >
        <Table responsive condensed>
          <thead>{headers}</thead>
          {rows}
          <tbody>
            <tr>
              {this.props.forks || this.props.spoons ? (
                <>
                  <td rowSpan="2" className="text-center sundrySpacer" />
                  <td rowSpan="2" className="text-center sundrySpacer" />
                </>
              ) : (
                ''
              )}
              {this.props.forks && (
                <>
                  <td>FORKS</td>
                  <td>{this.props.forks || 0}</td>
                </>
              )}
            </tr>
            <tr>
              {this.props.spoons && (
                <>
                  <td>SPOONS</td>
                  <td>{this.props.spoons || 0}</td>
                </>
              )}
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}
